<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TimelineMax as Line, Power1 } from 'gsap'
import Widget from '@/components/widget'

export default {

  name: 'DescriptionWidget',

  mixins: [Widget],

  data () {
    return {
      tl: null
    }
  },

  computed: {
    mainContent () {
      return this.$content.main
    },

    asideContent () {
      return this.$content.aside
    }
  },

  methods: {
    beforeAppear () {
      const tl = this.tl = new Line({ paused: true })

      tl.from(this.$refs.asideBg, 1, {
        scaleY: 0,
        ease: Power1.easeOut
      })

      tl.from(this.$refs.asideGraphic, 0.5, {
        y: -40,
        ease: Power1.easeOut
      }, 0.1)

      tl.from(this.$refs.asideContent, 1, {
        autoAlpha: 0,
        y: -20,
        ease: Power1.easeOut
      }, 0.5)

      tl.from(this.$refs.mainContent, 1, {
        autoAlpha: 0,
        y: -20,
        ease: Power1.easeOut
      }, 0.5)
    },

    appear () {
      this.tl.play()
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.description
  .description__wrapper

    .description__column.main
      .main__content(v-md="mainContent" ref="mainContent")

    .description__column.aside
      .aside__background(ref="asideBg")
      .aside__graphic(ref="asideGraphic")
      .aside__content(v-md="asideContent" ref="asideContent")

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.description
  display flex
  justify-content center
  padding-top 115px
  padding-bottom 90px

  +mobile()
    padding-top 90px

  &__wrapper
    display flex
    justify-content space-between
    align-items flex-start
    max-width 1218px
    width 100%
    padding-left 105px
    padding-right 27px

    +hd()
      max-width 1260px
      padding-left 60px
      padding-right 0

    +below(1024px)
      flex-direction column

    +tablet()
      padding 0 108px

    +mobile()
      padding 0 13px

  &__column
    max-width 50%

    +below(1024px)
      max-width 100%
      width 100%

.main
  display flex
  flex-direction column

  +tablet()
    margin-bottom 100px

  +mobile()
    margin-bottom 75px

  +above(1024px)
    width 400px
    padding-top 167px

  &__content
    font-size 17px
    line-height 25px

    +tablet()
      max-width 84%

    +mobile()
      font-size 13px
      line-height 20px

    h2
      font-weight 400
      font-size 56px
      line-height 57px
      color blue
      margin-bottom 40px

      +below(1023px)
        margin-bottom 100px
        font-size 46px
        line-height 50px
        font-weight normal

      +mobile()
        margin-bottom 75px

    p + p
      margin-top 25px

.aside
  position relative
  padding 166px 74px 85px
  color white
  overflow hidden

  +hd()
    width 640px
    height 500px

  +above(1024px)
    width 455px

  +tablet()
    padding 125px 130px 90px

  +mobile()
    padding 115px 24px 60px 40px

  &__background
    z-index 1
    content ''
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background-color blue
    transform-origin top

  &__graphic
    z-index 1
    content ''
    position absolute
    top 0
    left 74px
    display block
    width 0
    height 0
    border-left 31px solid orange
    border-bottom 35px solid transparent

  &__content
    z-index 2
    position relative
    font-size 14px
    line-height 23px

    h3
      font-weight 300
      font-size 26px
      line-height 34px
      padding-bottom 54px

    p
      max-width 268px

</style>



// WEBPACK FOOTER //
// description.vue?66fca093